import { notificationTemplate } from "./templates";
import { SHOW_NEW_PARTICLE_NOTIFICATION_TIME } from "./consts";

let updatesCounter = 0;

export default function particleNotify(particle) {
    if (!particle) {
        return null;
    }

    if (particle.getBoundingClientRect().top <= 0) {
        const notification = notificationTemplate.getElement();
        const button = notification.querySelector("button");

        button.innerText = `Updates (${++updatesCounter})`;
        button.addEventListener("click", () => {
            particle.scrollIntoView({ behavior: "smooth" });
            notification.remove();
            updatesCounter = 0;
        });

        document.body.appendChild(notification);

        setTimeout(() => {
            notification.remove();
            updatesCounter = 0;
        }, SHOW_NEW_PARTICLE_NOTIFICATION_TIME);
    }
}
